import React from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentSuccessScreen.css";
import eclipse from "../assets/splash-eclipse.png"; // Reuse your main menu background

import successImg from "../assets/success.png";
import DifficultyRating from "../components/DifficultyRating";
import { useState } from "react";

const PaymentSuccessScreen = () => {
  const [rating, setRating] = useState(null);

  const handleRating = (level) => {
    setRating(level);
    console.log("User rated difficulty:", level);
    // You could also send this to a server or save locally here
  };

  const navigate = useNavigate();

  return (
    <div className="success-screen">
      <img src={eclipse} alt="Eclipse background" className="success-eclipse" />

      <div className="success-box">
        <DifficultyRating onRate={handleRating} />
        <img src={successImg} alt="Success" className="success-image" />
        <div className="text-center mt-4 px-4">
          <h2 className="text-2xl font-bold text-purple-700 mb-2">Payment Received!</h2>
          <p className="text-gray-700 text-sm">Good job! Ready for the next challenge?</p>
        </div>


        <button
          className="success-button"
          onClick={() => navigate("/levels")}
        >
          Continue
        </button>
        <button className="success-button" onClick={() => navigate("/")}>
          Home
        </button>
        <button className="success-button" onClick={() => navigate("/levels")}>
          Choose Level
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessScreen;
